var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',{attrs:{"title":"Employee Codes"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('CodeList')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }